module.exports = __webpack_public_path__ + "img/banners_02.afc7f66c.jpg";